import { TrackingPageContext } from '@vfit/business-data-access';
import { useContext } from 'react';
import { ICurrentTracking } from './supportRegisterNumber.models';

const useSupportRegisterNumber = () => {
  const { currentDataLayer } = useContext(TrackingPageContext);

  // Filter out only the layers that are not empty
  const getCurrentDataLayer:ICurrentTracking = Object.entries(currentDataLayer).reduce((acc, [key, value]) => {
    const hasContent = Object.values(value).some((val) => {
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === 'object') return Object.keys(val).length > 0;
      return val !== undefined && val !== null && val !== '';
    });

    if (hasContent) {
      acc = value;
    }
    return acc;
  }, {});

  return {
    getCurrentDataLayer,
  };
};

export default useSupportRegisterNumber;
